<template>
    <div style="width: 100%;">
        <div style="width: 100%;">
            <div
                style="width: 100%;height:50px;text-align: center;font-size: 25px;font-weight: 600;color: #409EFF;margin-top: 30px;">
                {{ voteData.pvmTitle || '排行榜' }}
            </div>
            <div style="width: 100%;display: flex;flex-direction: column;align-items: center;">
                <!-- <div
                    style="width: 90px;height: 90px;border-radius: 100%;box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);">
                    <el-image style="width: 100%; height: 100%" :src="data.pmuHeaderOnline" fit="fill"></el-image>
                </div> -->
                <div
                    style="width: 100%;text-align: center;font-size: 18px;font-weight: 600;color: #409EFF;margin-top: 10px;">
                    欢迎您! {{item?item[0].createusername:'用户'}}
                </div>
                <div style="width: 90%;margin: 10px auto;border: 1px solid #F56C6C;">
                    <div style="width: 100%;text-align: center;font-size: 18px;font-weight: 600;color: #F56C6C;margin: 5px 0;">您的投票记录:</div>
                    <div style="width: 100%;text-align: center;font-size: 18px;font-weight: 600;color: #F56C6C;"
                    v-for="(items, index) in item || []" :key="index">
                    <div style="width: 100%;text-align: center;margin: 5px;">
                        {{ items.pzVoteItem.pviValue }}
                    </div>
                </div>
                </div>
               
            </div>

            <div
                style="width: 90%;margin: 15px auto;box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);overflow-y: auto;height: 280px;border: 1px solid #409EFF;padding: 10px 0;">
                <div style="width: 100%;display: flex;justify-content: space-around;align-items: center;border-bottom: 1px solid #DCDFE6;
                padding: 5px;" v-for="(datas,index) in data || []" :key="index">
                    <div style="width: 20%;text-align: center;">{{index+1}}</div> 
                    <div style="width: 50%;text-align: center;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{datas.name}}</div>
                    <div style="width: 30%;text-align: center;">{{datas.value}}</div> 
                </div>
            </div>
            
        </div>

    </div>
</template>

<script>

import {
    getPzVoteRecordRankUser
} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            item:'',
            pvmId: '',
            pmuId: '',
            checkboxGroup1: [],
            voteData: '',
            data: '',
            userLogin: true,
            isvote: false,
            form: {
                pvmId: '',
                pmuName: '',
            },
        };
    },
    activated() {

    },
    watch: {

    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.form.pvmId = this.getQueryParam('http://192.168.8.128:8080/#/voteUser?pvmId=1').pvmId;
        this.pvmId = this.$route.query.pvmId? this.$route.query.pvmId : localStorage.getItem('pvmId') ? localStorage.getItem('pvmId') : '';
        this.pmuId = localStorage.getItem('pmuId') ? localStorage.getItem('pmuId') : '';
        if (this.pmuId && this.pmuId) {
            getPzVoteRecordRankUser({
                pvmId: this.pvmId,
                pmuId: this.pmuId
            }).then(res => {
                this.data = res.data;
                this.item = res.item
            })
        } else {
            history.go(-1)
        }
    },
    mounted() { },
    methods: {
        toSubmit() {
            this.$confirm("是否确定投票,后续无法修改 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    const s = {
                        pvmId: this.form.pvmId,
                        pmuId: this.data.pmuId,
                        pviIds: JSON.parse(this.checkboxGroup1)
                    }
                    addPzVoteRecord(s).then(res => {
                        this.$message({
                            type: "success",
                            message: "投票成功!",
                        });
                        this.$router.push({
                            path: '/votePaiHang',
                            query: {
                                pmuId: this.data.pmuId
                            }
                        })

                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        gotoLogin() {
            getPzMainUserLogin(this.form).then(res => {
                this.userLogin = false;
                this.data = res.data;
                this.voteData = res.item;
                this.voteData.pvmTypeMultiMax = res.item.pvmTypeMultiMax * 1
                this.voteData.pvmTypeMultiMin = res.item.pvmTypeMultiMin * 1;
                document.title = res.item.pvmTitle;
                localStorage.setItem('pmuId', res.data.pmuId);
            })
        },
        getQueryParam(url) {
            var query = url.split('?')[1];
            var params = {};
            if (query) {
                var pairs = query.split('&');
                pairs.forEach(function (pair) {
                    var parts = pair.split('=');
                    params[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
                });
            }
            return params;

        }
    }
};
</script>

<style>
div .el-radio--medium.is-bordered {
    width: 100% !important;
    height: auto !important;
    padding: 5px 15px !important;
}

div .el-radio {
    white-space: inherit !important;
    line-height: 2 !important;
}

div .el-input--medium .el-input__inner {
    min-height: 10vw !important;
    line-height: 10vw !important;
    font-size: 0.6rem !important;
    text-align: center !important;
}

div .el-form-item__label {
    font-size: 0.6rem !important;
    padding: 10px 10px !important
}

div .el-button.is-round {
    border-radius: 9.667vw !important;
    padding: 2.6vw 8.067vw !important;
}

.labelStyle {
    color: red;
}

.el-message-box {
    width: 80%;
}

.disUoloadSty .el-upload--picture-card {
    display: none;
    /* 上传按钮隐藏 */
}

.el-upload--picture-card {
    width: 100%;
}

.el-upload-list--picture-card .el-upload-list__item {
    width: 100%;
}

html {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    margin: 0;
    padding: 0;

}

body {
    width: 100vw;
    margin: 0;
    padding: 10px;
    box-sizing: border-box;
}
</style>